// extracted by mini-css-extract-plugin
module.exports = {"Container":"Email_Container__1j4gi","Icon":"Email_Icon__1nCMC"};